import { z } from 'zod';

export const MAX_WEBHOOK_HEADERS = 10;

const HEADER_NAME_PATTERN = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;

export const webhookHeaderRowSchema = z.object({
  name: z.string().trim(),
  value: z.string().trim(),
  storedName: z.string(),
});

export type WebhookHeaderRow = z.infer<typeof webhookHeaderRowSchema>;

export const emptyWebhookHeaderRow: WebhookHeaderRow = {
  name: '',
  value: '',
  storedName: '',
};

export const webhookHeaderRowsFromNames = (names: string[]): WebhookHeaderRow[] =>
  names.map((name) => ({ name, value: '', storedName: name }));

export const webhookHeaderRowsToPayload = (
  rows: WebhookHeaderRow[]
): Record<string, string> | null => {
  const entries = rows
    .filter((row) => row.name.trim())
    .map((row) => [row.name.trim(), row.value.trim()]);
  return entries.length ? Object.fromEntries(entries) : null;
};

export const maskedWebhookHeaders = (names: string[]): string =>
  names.length ? names.map((name) => `${name}: ••••••`).join(', ') : 'Sin header';

export const addWebhookHeaderIssues = (
  rows: WebhookHeaderRow[],
  path: string,
  ctx: z.RefinementCtx
): void => {
  const names = new Set<string>();
  rows.forEach((row, index) => {
    const issue = (field: 'name' | 'value', message: string) =>
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: [path, index, field],
        message,
      });

    if (!row.name) {
      if (row.value) issue('name', 'Ingrese el nombre del header');
      return;
    }
    if (!HEADER_NAME_PATTERN.test(row.name)) {
      issue('name', 'Sin espacios ni dos puntos');
    } else if (names.has(row.name.toLowerCase())) {
      issue('name', 'Este header ya está cargado');
    }
    names.add(row.name.toLowerCase());

    const keepsStoredValue = !!row.storedName && row.storedName === row.name;
    if (!row.value && !keepsStoredValue) issue('value', 'Ingrese el valor del header');
  });
};
